import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './components/fullscreen.css';
import App from './App';

if (process.env.NODE_ENV === 'development') {
  const suppressedWarnings = [
    'ResizeObserver loop completed with undelivered notifications',
    'ResizeObserver loop limit exceeded'
  ];
  const realWarn = console.warn;
  const realError = console.error;
  console.warn = function(msg, ...args) {
    if (!suppressedWarnings.some(w => msg && msg.toString().includes(w))) {
      realWarn.apply(console, [msg, ...args]);
    }
  };
  console.error = function(msg, ...args) {
    if (!suppressedWarnings.some(w => msg && msg.toString().includes(w))) {
      realError.apply(console, [msg, ...args]);
    }
  };
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
